import React from 'react';
import { KanbanDividerColumn } from '../HBKanban.types';
import {
    StyledDividerWrapper,
    StyledDividerHeaderSpacer,
    StyledDivider
} from './HBKanbanDivider.styles';

const HBKanbanDivider = <TColumnData = any,>({
    column
}: {
    column: KanbanDividerColumn<TColumnData>;
}) => {
    return (
        <StyledDividerWrapper>
            <StyledDividerHeaderSpacer />
            <StyledDivider $color={column.color} />
        </StyledDividerWrapper>
    );
};

export default HBKanbanDivider;
